import SSOPaymentTransfer from './SSOPaymentTransfer';

export default SSOPaymentTransfer;
